/** @graphql cc **/

import gql from 'graphql-tag';

export const HelpPanelQuery = gql`
	query HelpPanelQuery {
		user: confluence_atlassianUser(current: true) {
			id
			displayName
			emails {
				value
				isPrimary
			}
		}
	}
`;
